import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7f2427e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = {
  class: "DialogBody P-Rel",
  style: {"width":"auto","max-width":"none"}
}
const _hoisted_4 = {
  class: "D-Flex",
  style: {"gap":"1em"}
}
const _hoisted_5 = { class: "F-Bold M-Auto" }
const _hoisted_6 = { class: "F-Bold M-Auto" }
const _hoisted_7 = {
  class: "DialogSection",
  id: "TableToPrint"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRow F-C2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_MainPageDateSelector = _resolveComponent("MainPageDateSelector")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!

  return (_openBlock(), _createElementBlock("div", {
    id: 'CookiesDialog_' + _ctx.DialogIndex,
    class: "CookiesDialogdBody"
  }, [
    (_ctx.Saving || _ctx.Loading.length)
      ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MainPageDateSelector, { ForceEnabled: true }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printIT())),
            class: "Shadow2 PrintButton D-Flex RowMargin NOPRINT"
          }, [
            _createVNode(_component_CookiesIcon, {
              class: "V-Auto",
              style: {"width":"1.1em","height":"1.7em","margin":"0 0.3em"},
              ID: 'Printer'
            }),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Translate('Print')), 1)
          ]),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
            class: "PrintButton Shadow2 BGRed D-Flex RowMargin NOPRINT",
            style: {"background-color":"var(--colorr1)"}
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.Translate('Close')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_CookiesTable, {
            CookiesInvalidInput: _ctx.TransferItems.length < 1,
            ErrorData: _ctx.ErrorsVisibilty && _ctx.TransferItems.length < 1,
            class: "Shadow1",
            TableSettings: _ctx.TableSettings,
            CookiesData: _ctx.TransferItems
          }, null, 8, ["CookiesInvalidInput", "ErrorData", "TableSettings", "CookiesData"])
        ]),
        _hoisted_9,
        _hoisted_10
      ])
    ])
  ], 8, _hoisted_1))
}